import { Component, OnInit } from '@angular/core';
import { MatDialog} from '@angular/material';
import {ProgramAddComponent} from './program-add/program-add.component';
import { User } from '../users/user.model';
import { AdalService} from '../shared/azure-authentication/adal.service';
import {UserService} from '../users/user.service';

@Component({
  selector: 'app-loan-programs',
  templateUrl: './loanprograms.component.html',
  styleUrls: ['./loanprograms.component.css']
})
export class LoanProgramsComponent implements OnInit {
    isAdmin: boolean;
    isAuthenticatedSubscription: any;
  public  user = new User();
  constructor(public dialog: MatDialog, private adalService: AdalService, private userService: UserService) {
  }

    ngOnInit() {
        this.isAuthenticatedSubscription = this.userService.currentUserAuthenticated.subscribe((currentUser: User) => {
            this.isAdmin = currentUser.isAdmin;
        });
    }

    ngOnDestroy() {
        if (this.isAuthenticatedSubscription) this.isAuthenticatedSubscription.unsubscribe();
    }

  openProgramAddDialog() {
    this.dialog.open(ProgramAddComponent,
        {
            height: "505px",
            width: "590px",
            panelClass:"add-program-dialog"
      });
  }
} 



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/loanprograms/loanprograms.component.ts